import { createAction } from 'redux-act';

export const ssoInitCompleted = createAction('ssoUser/INIT_COMPLETED');
export const ssoLoginSuccess = createAction('ssoUser/LOGIN_SUCCESS');
export const ssoLogoutSuccess = createAction('ssoUser/LOGOUT_SUCCESS');
export const ssoSyncProfile = createAction('ssoUser/PROFILE_SYNC_SUCCESS');
